export const setUsers = (state, users) => {
    state.users = users;
}

export const setCurrentUser = (state, user) => {
    state.currentUser = user;
    state.loading = false
}

export const setUser = (state, user) => {
    state.user = user;
    sessionStorage.setItem('user',JSON.stringify(user))
    state.loading = false
}

export const setTotals = (state, totals) => {
    state.totals = totals;
}

export const setLoading = (state, loading) => {
    state.loading = loading
}

export const setErrorMessage = (state, errorMessage) => {
    state.errorMessage = errorMessage
}